import axios, { AxiosResponse } from 'axios';
import { ProductMenuResourcesSearchRequest, ProductMenuResourcesSearchResponse, PageDto } from '@/venit/services/model/techpubs-cms';

export default class ApiProductService {
  public search(
    menuId: number,
    productId: string,
    productUrlId: string,
    page: PageDto,
    lang: string
  ): Promise<AxiosResponse<ProductMenuResourcesSearchResponse>> {
    const request: ProductMenuResourcesSearchRequest = {
      menuId,
      productId,
      productUrlId: null,
      page,
      lang,
    };
    return axios.post<ProductMenuResourcesSearchResponse>('/api/v1/products/search', request);
  }
}
